import React from 'react'
import PropTypes from 'prop-types'
import styles from './table.styl'

const TableLoader = ({ loading, ths }) => (
  <div>
    {loading &&
      <div className={styles.loader}>
        {ths.map(th => (
          <div key={th.id} className={styles.loaderColumn}>
            <span className={styles.loaderHeader}>{th.label || 'Column'}</span>
          </div>
        ))}
      </div>}
  </div>
)

TableLoader.propTypes = {
  loading: PropTypes.bool,
  ths: PropTypes.array
}

TableLoader.defaultProps = {
  ths: []
}

export default TableLoader
